import routeDataFromJson from "../route/mapper";
import VoyageRouteData from "./data";

export default function voyageRouteDataFromJson(json) {
    return new VoyageRouteData(
        json.voyageId,
        json.computation,
        json.routes.map((route) => routeDataFromJson(route))
    );
}